<template>
  <v-container class="px-0 py-0">
     <v-row class="ma-0 pa-3 mb-5" style="background-color:#d1dcea">
            <v-col cols="2" class="pa-0 ma-0">
              <div class="px-0 pt-2">
                <b>{{info.oper_nome}}</b><br>
                {{info.prest_nome}}
              </div>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col class="text-list text-right px-0 py-1"><small>Vl. informado (R$):</small><br><b>{{info.valor_informado_total | formatPrice }}</b></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Vl. lib. de produção (R$):</small><br><b style="color:green">{{info.valor_liberado_total | formatPrice }}</b></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Glosa Inicial (R$):</small><br><b><span style="color:red">{{info.valor_glosado_total | formatPrice }}</span></b></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Vl. lib. de recurso (R$):</small><br><b style="color:green">{{info.valor_pago_recurso_total | formatPrice }}</b></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Glosa mantida (R$):</small><br><span style="color:red">{{info.valor_glosa_mantida_total | formatPrice }}</span></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Glosa recursada (R$):</small><br><span style="color:green">{{info.valor_recursado_total | formatPrice }}</span></v-col>
                <v-col class="text-list text-right px-0 py-1"><small>Glosa acatada (R$):</small><br><span style="color:red">{{info.valor_acatado_total | formatPrice }}</span></v-col>

              </v-row>
            </v-col>
      </v-row>
      <v-row class="px-0 py-0">

        <v-col cols="12" class="px-1 py-0">
          <Tabela :headers="headers" tableName="conciliados" title="Valores conciliados" :list="info.conciliado" :pagamentoPublicado="true"/>
          <p class="text-right my-n3 pr-3"><small>Valores em Reais (R$)</small></p>
        </v-col>
        <v-col cols="12" class="px-1 py-0">
          <Tabela :headers="headersEstratificado" tableName="estratificados" title="Valores estratificados"  :list="info.estratificado" :pagamentoPublicado="true"/>
          <p class="text-right mt-n3 pr-3"><small>Valores em Reais (R$)</small></p>
        </v-col>

      </v-row>

    </v-container>
</template>

<script>
import moment from 'moment'
import Tabela from './dataTable'
export default {
  props: {
    info: Object
  },
  components:{
    Tabela
  },
  data() {
    return {
       headers: [
        { text: "Vl.informado", value: "valor_informado", align: "right", sortable: false },
        { text: "Vl.liberado", value: "valor_liberado", align: "right", sortable: false },
        { text: "Glosa Inicial", value: "valor_glosado", align: "right", sortable: false },
        // { text: "Vl.lib. de recurso", value: "val_liberado", align: "right", sortable: false },
        // { text: "Glosa mantida", value: "val_glos_mant", align: "right", sortable: false },
        { text: "Glosa recursada", value: "valor_recursado", align: "right", sortable: false },
        { text: "Glosa acatada", value: "valor_acatado", align: "right", sortable: false },
      ],
      headersEstratificado: [
        { text: "Vl.informado", value: "valor_informado", align: "right", sortable: false },
        { text: "Vl.liberado", value: "valor_liberado", align: "right", sortable: false },
        { text: "Glosa Inicial", value: "valor_glosado", align: "right", sortable: false },
        // { text: "Vl.lib. de recurso", value: "val_liberado", align: "right", sortable: false },
        { text: "Glosa recursada", value: "valor_recursado", align: "right", sortable: false },
        { text: "Glosa acatada", value: "valor_acatado", align: "right", sortable: false },
      ],
    }
  },
  filters:{
    formatData(val){
      return  moment(val).format('DD/MM/YYYY')
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  mounted(){
     let message = []
        if(this.info.config && this.info.config.FAT_DADOS_ENTREGA_OBRIGATORIO){
          message.push('dados de entrega')
        }
        if(this.info.config && this.info.config.FAT_NOTA_FISCAL_OBRIGATORIO){
          message.push('nota fiscal')
        }
        if(this.info.config && this.info.config.FAT_CAPA_LOTE_OBRIGATORIO){
          message.push('capa de lote')
        }
        this.warningMessageType = 'warning'
        if(message.length == 1){
          message = message[0]
          message = `Operadora com obrigatoriedade de ${message}.`
        } else if (message.length > 1) {
          let ultima =  message.pop();
          message = message.join(', ') + ' e ' + ultima
          message = `Operadora com obrigatoriedade de ${message}.`
        } else if (this.info.status=="F") {
          message = `Cronograma concluído.` // em  ${this.info.dt_alteracao}
          this.warningMessageType = 'success'
        } else {
          message = ""
        }
        this.warningMessage = message
        this.warningMessageShow = message.length && this.info.status != 'F' ? true : false
  }
}
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
p.texts {
font-size: 18px;
font-weight: bold;
}
.ematraso {
  color: #FC9D0A;
  font-weight: bold;
}
</style>
